__turbopack_context__.v({
  "arrow": "DropdownItem-module-scss-module__Vkmboq__arrow",
  "dropdownItem": "DropdownItem-module-scss-module__Vkmboq__dropdownItem",
  "dropdownMenu": "DropdownItem-module-scss-module__Vkmboq__dropdownMenu",
  "dropdownTrigger": "DropdownItem-module-scss-module__Vkmboq__dropdownTrigger",
  "navLink": "DropdownItem-module-scss-module__Vkmboq__navLink",
  "rotated": "DropdownItem-module-scss-module__Vkmboq__rotated",
  "slideDown": "DropdownItem-module-scss-module__Vkmboq__slideDown",
});
